export function normalizeSearch(searchTerm: string) {
    let s = '';

    s = searchTerm.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    s = s.replace(/[^a-zA-Z0-9-_]/g, '');
    s = s.toLowerCase();

    return s;
}
